import React from "react";
import { useTranslation } from "react-i18next";
import { VisitOutcome } from "../../features/sessions/models/VisitOutcome";

interface BulkOutcomeButtonsProps {
  memberIds: string[];
  onSetMany: (memberIds: string[], outcome: VisitOutcome) => void;
}

/** The one-tap bulk row above the roster: mark everyone attended or absent. */
const BulkOutcomeButtons: React.FC<BulkOutcomeButtonsProps> = ({ memberIds, onSetMany }) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-wrap gap-2">
      <button
        type="button"
        onClick={() => onSetMany(memberIds, VisitOutcome.Attended)}
        className="rounded-lg bg-green-100 px-3 py-1.5 text-sm font-medium text-green-800 hover:bg-green-200 dark:bg-green-900/30 dark:text-green-300 dark:hover:bg-green-900/50"
      >
        {t("sessions.attendance.allAttended")}
      </button>
      <button
        type="button"
        onClick={() => onSetMany(memberIds, VisitOutcome.CancelledCharged)}
        className="rounded-lg bg-grey-95 px-3 py-1.5 text-sm font-medium text-grey-30 hover:bg-grey-90 dark:bg-primary-20 dark:text-grey-70 dark:hover:bg-primary-20"
      >
        {t("sessions.attendance.allAbsent")}
      </button>
    </div>
  );
};

export default BulkOutcomeButtons;
